import {useEffect, useState} from 'react'

import {defer} from 'es-toolkit/compat'

const useMemoDeferred = <T>(factory: () => T, deps: unknown[], getInitialValue: () => T) => {
  const [value, setValue] = useState<T>(getInitialValue)

  useEffect(() => {
    defer(() => setValue(factory()))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)

  return value
}

export default useMemoDeferred
